<template>
    <ul class="navbar-nav menu-principal__items" :class="{ 'mm-listview': isMobile }">
        <NavLink :isMobile="isMobile" :class="{ 'mm-listitem': isMobile }" :href="'#'" :active="$page.component.startsWith('GobiernoMunicipal')" :text="'Gobierno Municipal'" :principal="true" :hasSubmenu="true">
            <ul>
                <NavLink @click="$emit('close')" href="/gobierno-municipal/alcalde" :active="$page.component == 'GobiernoMunicipal/alcalde'">Alcalde</NavLink>
                <NavLink @click="$emit('close')" href="/gobierno-municipal/integrantes-del-cabildo" :active="$page.component == 'GobiernoMunicipal/Cabildo'">Integrantes del Cabildo
                </NavLink>
                <NavLink @click="$emit('close')" href="/gobierno-municipal/dependencias-municipales" :active="$page.component == 'GobiernoMunicipal/Secretarias'">Dependencias Municipales
                </NavLink>
                <NavLink @click="$emit('close')" href="/gobierno-municipal/titulares-dependencias" :active="$page.component == 'GobiernoMunicipal/titulares-dependencias'">Titulares de las Dependencias</NavLink>
                <NavLink @click="$emit('close')" href="/gobierno-municipal/comisiones" :active="$page.component == 'GobiernoMunicipal/Comisiones'">Comisiones</NavLink>
                <NavLink @click="$emit('close')" href="/gobierno-municipal/directorio" :active="$page.component == 'GobiernoMunicipal/Directorio'">Directorio</NavLink>
                <NavLink @click="$emit('close')" href="/gobierno-municipal/marco-normativo" :active="$page.component == 'GobiernoMunicipal/MarcoNormativo'">Marco Normativo</NavLink>
                <NavLink @click="$emit('close')" href="/te_escuchamos" :active="$page.component == 'Sugerencias'">Te Escuchamos</NavLink>
            </ul>
        </NavLink>
        <NavLink :isMobile="isMobile" :class="{ 'mm-listitem': isMobile }" href="#" :active="$page.component.startsWith('Turismo')" :text="'Turismo'" :principal="true" :hasSubmenu="true">
            <ul>
                <NavLink @click="$emit('close')" href="/turismo/directorio-turistico">Directorio Turístico</NavLink>
                <NavLink @click="$emit('close')" href="/turismo/historia">Historia</NavLink>
                <NavLink @click="$emit('close')" href="/turismo/lugares-de-interes">Lugares de Interés</NavLink>
            </ul>
        </NavLink>

        <NavLink :isMobile="isMobile" :class="{ 'mm-listitem': isMobile }" href="#" :active="$page.component.startsWith('Servicios') || $page.component.startsWith('Programas') || $page.component.startsWith('MejoraRegulatoria')" :text="'Trámites y Programas'" :principal="true" :hasSubmenu="true">
            <ul>
                <NavLink @click="$emit('close')" href="/servicios" :active="$page.component == 'Servicios'">Trámites y Servicios
                </NavLink>
                <NavLink @click="$emit('close')" href="/programas" :active="$page.component == 'Programas'">Programas
                </NavLink>
                <NavLink @click="$emit('close')" href="/mejora-regulatoria" :active="$page.component.startsWith('MejoraRegulatoria')">Mejora Regulatoria
                </NavLink>
            </ul>
        </NavLink>

        <NavLink :isMobile="isMobile" :class="{ 'mm-listitem': isMobile }" href="#" :active="$page.component.startsWith('Noticias') || $page.component.startsWith('Eventos')" :text="'Noticias y Eventos'" :principal="true" :hasSubmenu="true">
            <ul>
                <NavLink @click="$emit('close')" href="/noticias" :active="$page.component == 'Noticias/Noticias'">Noticias
                </NavLink>
                <NavLink @click="$emit('close')" href="/eventos" :active="$page.component == 'Eventos'">Eventos
                </NavLink>
            </ul>
        </NavLink>
        <NavLink :isMobile="isMobile" :class="{ 'mm-listitem': isMobile }" href="#" :active="$page.component.startsWith('Transparencia')" :text="'Transparencia'" :principal="true" :hasSubmenu="true">
            <ul>
                <a href="https://portaltransparencia.santiago.gob.mx/">Portal de Transparencia</a>
                <a href="https://mirror.santiago.gob.mx/informacion-publica/">Información Pública</a>
                <NavLink @click="$emit('close')" href="/transparencia/solicitudes-de-informacion">Solicitudes de información</NavLink>
                <NavLink @click="$emit('close')" href="/apoyo-covid">Apoyo Covid</NavLink>
                <a href="https://nuevoleon.opendatasoft.com/pages/santiago/">Datos Abiertos</a>
            </ul>
        </NavLink>
        <NavLink :isMobile="isMobile" :class="{ 'mm-listitem': isMobile }" href="#" :active="$page.component.startsWith('Dif')" :text="'DIF'" :principal="true" :hasSubmenu="true">
            <ul style="right: 0;">
                <NavLink @click="$emit('close')" href="/dif/centros-dif">Centros DIF</NavLink>
                <NavLink @click="$emit('close')" href="/dif/servicios">Trámites y Servicios</NavLink>
                <NavLink @click="$emit('close')" href="/dif/programas">Programas</NavLink>
            </ul>
        </NavLink>
        <NavLink @click="$emit('close')" v-if="isMobile" :isMobile="isMobile" :class="{ 'mm-listitem buscador': isMobile }" href="/buscador" :html="true">Buscar <i class="fi fi-search ml8-1"></i></NavLink>
        <li class="menu-principal-item menu-principal-item--buscar-lg dropdown">
            <span @click="$emit('open')" class="boton-buscar" data-toggle="dropdown"><span class="sr-only">Buscar</span></span>
        </li>
        <!--{{ $page.component }}-->
    </ul>
</template>
<script>
import NavLink from "./NavLink.vue";
import { Link, useForm } from '@inertiajs/inertia-vue3'

export default {
    props: {
        isMobile: Boolean,
        function: Object,
        functionBuscador: Object,
    },
    computed() {
        const close = this.function;
        const open = this.functionBuscador;
    },
    components: { NavLink, Link },
    methods: {
        closeMenu: close,
        openBuscador: open,
    },
    setup(props, context) {
        const form = useForm({
            buscar: '',
            categoria: '',
        });

        function submit() {
            form.get('/buscador', {
                preserveScroll: false,
                onSuccess: function () {
                    context.emit('close')
                    form.reset()
                },
            });
        }

        return {
            form, submit
        }
    },
}
</script>
<style scoped>
.buscador {
    display: flex;
    align-items: center;
    flex-direction: row;
}
</style>
